import Vue from 'vue'
import Vuex from 'vuex'
import { serializeBPhone, serializePhone } from '@/canvas/components/form/utils'
import { useAjax } from '@/canvas/plugin/request'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    history: {
      isEmpty: true
    },
    bPhoneInfo: null,
    // 手机号授权弹窗
    phoneAuthModal: {
      hasShow: false, // 是否已展示
      agree: false // 是否同意授权
    },
    // 位置信息授权弹窗
    locationAuthModal: {
      hasShow: false, // 是否已展示
      agree: false // 是否同意授权
    }
  },
  mutations: {
    setBPhoneInfo(state, data) {
      state.bPhoneInfo = data
    },
    setHistoryByPhone(state, history) {
      state.history = history
    },
    setPhoneAuthModal(state, data) {
      state.phoneAuthModal = data
    },
    setLocationAuthModal(state, data) {
      state.locationAuthModal = data
    }
  },
  actions: {
    queryBPhone({ commit, state }) {
      const { bPhoneInfo } = state || {}

      if (bPhoneInfo) {
        return Promise.resolve(bPhoneInfo)
      }
      return useAjax()
        .post('v1/form_data/user/info', serializeBPhone())
        .then((res) => {
          const { data, code } = res || {}
          if (code === 0 && data) {
            commit('setBPhoneInfo', data)
            return data
          }
        })
    },
    queryHistoryByPhone({ commit, state }) {
      if (!window.alita) return
      const { history } = state || {}

      if (history && !history.isEmpty) {
        return Promise.resolve(state.history)
      }

      return useAjax()
        .post('v1/form_data/phone', serializePhone())
        .then((res) => {
          const { data, code } = res || {}
          if (code === 0 && data) {
            commit('setHistoryByPhone', data)
            return data
          }
        })
    }
  }
})

export default store
